/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Injectable } from '@angular/core';

import { ApiService } from 'rest-client';

@Injectable()
export class ErrorReportService {
  constructor(private apiService: ApiService) { }

  sendReport(err: any, context: string, snapshot: any): void {
    if(err?.error?.error == 'API_ERROR_RESERVATION_IS_CANCELLED') {
      //do nothing with this kind of error
      console.log('API_ERROR_RESERVATION_IS_CANCELLED errors are not being notified')
    } else {
      this.apiService.notifyError(err, context, snapshot);
    }
  }
}
